import { createSelector } from '@ngrx/store';

import { mapHotelDetailRoom, mapHotelDetailMarkers } from '@hotels/hotel-detail/mappers/hotel-detail.mapper';
import { HotelDetailModuleState } from '@hotels/hotel-detail/store/state/hotel-detail-module.state';
import { hotelDetailRootSelector } from '@hotels/hotel-detail/store/selectors/hotel-detail-root.selector';

export const getHotelDetailState = createSelector(
  hotelDetailRootSelector,
  (state: HotelDetailModuleState) => state.hotelDetail
);

export const hotelDetailSelector = createSelector(getHotelDetailState, mapHotelDetailRoom);
export const hotelMarkersSelector = createSelector(hotelDetailSelector, mapHotelDetailMarkers);
